import {Zlib} from "zlibjs/bin/zlib.min";

    export function callService(url, postData, options, attempts) {
        if (options.showWaitCursor) { $("html").addClass("wait")};
        attempts = typeof attempts == "number" ? attempts : 0;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            url = options.method == "GET" ? url + "?" + _encodePostData(postData) : url;
            xhr.open(options.method, url, options.async);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhr.onreadystatechange = function() {
                $("html").removeClass("wait");
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var response;
                    try {
                        response = JSON.parse(xhr.response);//error when response is incomplete
                        if (typeof response.results != "undefined" && !response.results[1].value) {
                            //service success, resolve response even if falsy
                            resolve(response.results[0].value);
                        } else if (typeof response.results != "undefined" && response.results[1].value) {
                            //service handled internal error
                            reject(response.results[1].value);
                        } else if (typeof response.error != "undefined" && response.error.code == 499 && response.error.message == "Token Required"){
                            //Token required
                            reject("Veuillez vous identifier.")
                        } else if (typeof response.error != "undefined" && response.error.code == 403){
                            //User does not have permissions to access
                            reject("Vous n'avez pas accès à ces données.")
                        } else if (typeof response.error != "undefined"){
                            //service unhandled internal error
                            reject("Erreur du service. Veuillez noter l'heure et communiquer le problème à <a href=\"mailto:informationsgeographiques@education.gouv.qc.ca\" target=\"_blank\">informationsgeographiques@education.gouv.qc.ca</a>")
                        }
                    } catch (e) {
                        reject(++attempts);
                    }
                }
            };
            xhr.onerror = function() {
                //service HTTP error
                reject(++attempts);
            };
            xhr.send(options.method == "POST" ? _encodePostData(postData) : null);
        }).then(function(response) {
            return options.compressedOutput ? JSON.parse(inflate(response)) : response;
        }).catch(function(error) {
            if (typeof error == "number") {
                if (error < 3) {
                    return callService(url, postData, options, error);
                } else {
                    return Promise.reject(new Error("ServerUtils._callService() - request from: " + url + " exeeded 3 attempts."));
                }
            } else {
                return Promise.reject(error);
            }
        });
    };

    export function inflate(response) {
        var inflate = new Zlib.Inflate(str2Uint8Array(atob(response))),
            plain = inflate.decompress();
        return uint8Array2str(plain);
    };

    export function deflate(postData) {
        var deflate = new Zlib.Deflate(str2Uint8Array(encodeURIComponent(JSON.stringify(postData)))),
            plain = deflate.compress();
        return btoa(uint8Array2str(plain));
    };

    export function uint8Array2str(uint8array) {
        var CHUNK_SZ = 0x8000,
            c = [];
        for (var i=0, u8aLen=uint8array.length; i < u8aLen; i+=CHUNK_SZ) {
            c.push(String.fromCharCode.apply(null, uint8array.subarray(i, i+CHUNK_SZ)));
        }
        return c.join("");
    };

    export function str2Uint8Array(str) {
        var uint8Array = new Uint8Array(str.length);
        for (var i=0, strLen=str.length; i < strLen; i++) {
            uint8Array[i] = str.charCodeAt(i);
        }
        return uint8Array;
    };

    function _encodePostData(postData) {
        var encodedPostData = [];
        for (var param in postData) {
            encodedPostData.push(encodeURIComponent(param) + "=" + encodeURIComponent(postData[param]));
        }
        return encodedPostData.join("&");
    };

    export function downloadBlob(data, filename, MIMEtype) {
        var blob = new Blob([data], {"type": MIMEtype});
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display:none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }
    };
